export default "__VITE_ASSET__G7U6jA47__"